(() => {
  const configEl = document.querySelector('[data-ke-restock-config]');
  if (!configEl) return;

  const endpoint = (configEl.dataset.endpoint || '').replace(/\/$/, '');
  const locale = (configEl.dataset.locale || document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
  if (!/^https:\/\//i.test(endpoint)) return;

  const i18n = {
    de: {
      open: 'Benachrichtigen, wenn verfügbar',
      title: 'Informieren, sobald verfügbar',
      email: 'E-Mail-Adresse',
      consent: 'Ich möchte eine Bestätigung dieser Anmeldung und eine E-Mail erhalten, sobald diese Variante wieder verfügbar ist.',
      privacy: 'Datenschutzerklärung',
      cancel: 'Abbrechen',
      submit: 'Benachrichtigung aktivieren',
      sending: 'Wird gespeichert …',
      success: 'Benachrichtigung aktiviert. Wir informieren dich per E-Mail, sobald diese Variante wieder an Lager ist.',
      confirmed: 'Benachrichtigung aktiviert',
      error: 'Das hat nicht funktioniert. Bitte versuche es nochmals.',
      close: 'Schliessen'
    },
    en: {
      open: 'Notify me when available',
      title: 'Notify me when available',
      email: 'Email address',
      consent: 'I want to receive confirmation of this registration and an email when this variant is back in stock.',
      privacy: 'Privacy policy',
      cancel: 'Cancel',
      submit: 'Activate notification',
      sending: 'Saving …',
      success: 'Done. We will email you once when this variant is back in stock.',
      confirmed: 'Notification activated',
      error: 'Something went wrong. Please try again.',
      close: 'Close'
    },
    fr: {
      open: 'Me prévenir dès disponibilité',
      title: 'Me prévenir dès disponibilité',
      email: 'Adresse e-mail',
      consent: 'Je souhaite recevoir une confirmation de cette inscription et un e-mail lorsque cette variante sera de nouveau en stock.',
      privacy: 'Politique de confidentialité',
      cancel: 'Annuler',
      submit: 'Activer la notification',
      sending: 'Enregistrement …',
      success: 'C’est fait. Nous vous enverrons un seul e-mail lorsque cette variante sera de nouveau disponible.',
      confirmed: 'Notification activée',
      error: 'Une erreur est survenue. Veuillez réessayer.',
      close: 'Fermer'
    }
  };
  const t = i18n[locale] || i18n.de;

  const modal = document.createElement('div');
  modal.className = 'ke-restock-modal';
  modal.hidden = true;
  modal.innerHTML = `
    <div class="ke-restock-modal__backdrop" data-ke-close></div>
    <div class="ke-restock-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="ke-restock-title">
      <button class="ke-restock-modal__x" type="button" aria-label="${t.close}" data-ke-close>×</button>
      <h2 id="ke-restock-title">${t.title}</h2>
      <p class="ke-restock-modal__variant" data-ke-variant-copy></p>
      <form data-ke-form>
        <label class="ke-restock-label">${t.email}
          <input class="ke-restock-input" type="email" name="email" required autocomplete="email" maxlength="254">
        </label>
        <label class="ke-restock-honeypot" aria-hidden="true">Company<input type="text" name="company" tabindex="-1" autocomplete="off"></label>
        <label class="ke-restock-consent">
          <input type="checkbox" name="consent" required>
          <span>${t.consent} <a href="/policies/privacy-policy" target="_blank" rel="noopener">${t.privacy}</a>.</span>
        </label>
        <div class="ke-restock-actions">
          <button class="ke-restock-secondary" type="button" data-ke-close>${t.cancel}</button>
          <button class="ke-restock-primary" type="submit">${t.submit}</button>
        </div>
        <p class="ke-restock-status" data-ke-status aria-live="polite"></p>
      </form>
    </div>`;
  document.body.appendChild(modal);

  let active = null;
  const form = modal.querySelector('[data-ke-form]');
  const status = modal.querySelector('[data-ke-status]');
  const submit = modal.querySelector('.ke-restock-primary');
  const variantCopy = modal.querySelector('[data-ke-variant-copy]');

  function close() {
    modal.hidden = true;
    document.documentElement.classList.remove('ke-restock-open');
    status.textContent = '';
    active?.trigger?.focus?.();
  }

  modal.querySelectorAll('[data-ke-close]').forEach(element => element.addEventListener('click', close));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !modal.hidden) close();
  });

  document.querySelectorAll('.kbrw-row__form').forEach(rowForm => {
    const unavailable = rowForm.querySelector('.kbrw-row__button[disabled]');
    const idInput = rowForm.querySelector('input[name="id"]');
    if (!unavailable || !idInput) return;

    const row = rowForm.closest('[data-kbrw-row]') || rowForm.closest('tr');
    const variantTitle = idInput.dataset.keVariantTitle || row?.querySelector('.kbrw-row__name')?.textContent?.trim() || 'Variante';
    const rawId = String(idInput.value || '').trim();
    const variantId = rawId.startsWith('gid://') ? rawId : `gid://shopify/ProductVariant/${rawId}`;

    unavailable.hidden = true;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'kbrw-row__button ke-restock-trigger';
    button.textContent = t.open;
    button.addEventListener('click', () => {
      if (submit.disabled) return;
      form.hidden = false;
      modal.querySelector('[data-ke-inline-success]')?.remove();
      modal.querySelector('#ke-restock-title').textContent = t.title;
      active = { trigger: button, variantId, variantTitle };
      variantCopy.textContent = variantTitle;
      modal.hidden = false;
      document.documentElement.classList.add('ke-restock-open');
      setTimeout(() => form.elements.email?.focus(), 0);
    });
    rowForm.appendChild(button);
  });

  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (!active || submit.disabled) return;
    const selected = { ...active };
    status.textContent = t.sending;
    submit.disabled = true;

    try {
      const response = await fetch(`${endpoint}/api/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: form.elements.email.value,
          consent: form.elements.consent.checked,
          company: form.elements.company.value,
          variantId: selected.variantId,
          productTitle: document.querySelector('.kbrw__title')?.textContent?.trim() || document.title,
          variantTitle: selected.variantTitle,
          productUrl: location.href.split('#')[0].split('?')[0],
          locale
        })
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const result = await response.json();
      if (result.ok !== true) throw new Error('Subscription was not saved');
      status.textContent = t.success;
      form.reset();
      const variantId = selected.variantId.split('/').pop();
      const destination = new URL(location.href);
      destination.hash = '';
      destination.searchParams.set('view', 'restock-confirmed');
      destination.searchParams.set('variant', variantId);
      try {
        sessionStorage.setItem(`ke-restock-confirmation:${destination.pathname}`, JSON.stringify({
          variantId,
          savedAt: Date.now(),
          confirmationStatus: result.confirmationStatus || 'not_requested'
        }));
        location.assign(destination.href);
      } catch {
        form.hidden = true;
        const heading = modal.querySelector('#ke-restock-title');
        heading.textContent = t.confirmed;
        const message = document.createElement('p');
        message.dataset.keInlineSuccess = '';
        message.setAttribute('role', 'status');
        message.textContent = t.success;
        form.before(message);
        modal.hidden = false;
        document.documentElement.classList.add('ke-restock-open');
        modal.querySelector('.ke-restock-modal__x').focus();
      }
    } catch (error) {
      console.error('KE Restock', error);
      status.textContent = t.error;
    } finally {
      submit.disabled = false;
    }
  });
})();
